"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.POSNoteSearch = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_select_1 = __importDefault(require("react-select"));
const useFetch_1 = __importDefault(require("../../../../hooks/useFetch"));
const apiUtils_1 = require("../../../../util/apiUtils");
const getPOSNoteOption = (posNote) => ({
    value: posNote,
    label: posNote.document_id
        ? `${posNote.name} (${posNote.document_id})`
        : posNote.name,
});
const POSNoteSearch = ({ selectedPOSData, selectedPOSId, onChange, }) => {
    const [searchQuery, setSearchQuery] = (0, react_1.useState)("");
    const [selected, setSelected] = (0, react_1.useState)(null);
    const [searchError, setSearchError] = (0, react_1.useState)(null);
    const [displayPOSNotes, setDisplayPOSNotes] = (0, react_1.useState)(undefined);
    const [posNotesResponse, setUrl, setBody] = (0, useFetch_1.default)(undefined, undefined);
    (0, react_1.useEffect)(() => {
        if (selectedPOSId == null) {
            setSelected(null);
            return;
        }
        if (selected?.value.id === selectedPOSId) {
            return;
        }
        if (selectedPOSData && selectedPOSData.id === selectedPOSId) {
            setSelected(getPOSNoteOption(selectedPOSData));
        }
    }, [selected, selectedPOSData, selectedPOSId]);
    (0, react_1.useEffect)(() => {
        const trimmed = searchQuery.trim();
        if (trimmed.length < 3) {
            setDisplayPOSNotes(undefined);
            setSearchError(null);
            return;
        }
        const timeoutFunction = setTimeout(() => {
            setSearchError(null);
            setBody(JSON.stringify({
                search: trimmed,
            }));
            setUrl("admin/proof_of_sustainability_search.json");
        }, 300);
        return () => clearTimeout(timeoutFunction);
    }, [searchQuery, setBody, setUrl]);
    (0, react_1.useEffect)(() => {
        if (posNotesResponse.status === apiUtils_1.LoaderStatus.Success &&
            posNotesResponse.data) {
            setSearchError(null);
            setDisplayPOSNotes(posNotesResponse.data);
        }
        else if (posNotesResponse.status === apiUtils_1.LoaderStatus.Error) {
            setSearchError("Search failed; please try again.");
            setDisplayPOSNotes(undefined);
        }
    }, [posNotesResponse]);
    const options = (0, react_1.useMemo)(() => {
        if (!displayPOSNotes || !Array.isArray(displayPOSNotes)) {
            return [];
        }
        return displayPOSNotes.map(getPOSNoteOption);
    }, [displayPOSNotes]);
    const handleSelectPOSNote = (option) => {
        setSelected(option);
        onChange(option?.value ?? null);
    };
    return ((0, jsx_runtime_1.jsx)(react_select_1.default, { isClearable: true, isSearchable: true, placeholder: "...Search for POS note", value: selected, options: options, onChange: handleSelectPOSNote, onInputChange: (value) => setSearchQuery(value), isLoading: posNotesResponse.status === apiUtils_1.LoaderStatus.Loading, styles: {
            container: (basestyles) => ({
                ...basestyles,
                width: "100%",
            }),
        }, noOptionsMessage: () => {
            if (searchError) {
                return searchError;
            }
            if (searchQuery.trim().length < 3) {
                return "Type at least 3 characters to search";
            }
            return "No POS notes found";
        } }));
};
exports.POSNoteSearch = POSNoteSearch;
